import { createPatchEndpoint } from '@sonar-software/sonar-http';

export type PatchAdminFeatureFlagByIdRequest = {
    id: string,
    forcedValue?: boolean | null,
    groupId?: number | null,
    groupName?: string | null,
    defaultValue?: boolean,
};

export const patchAdminFeatureFlagById = createPatchEndpoint<PatchAdminFeatureFlagByIdRequest>(
	(request) => `/api/v3/core/feature-flags/${request.id}`, {
		requestTransform: ({ groupName, ...rest }) => rest
	}
);
